import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLoginToken, validateToken } from './Conectionclient';
import { Button, Modal } from 'react-bootstrap';
import { AppContext } from './App';
import './Login.css';
import Cookies from 'js-cookie';
import { SERVER_URL } from './config';
import axios from 'axios';


// Error Modal for Login Errors
const ErrorModal = ({ open, onClose }) => {
    return (
        <Modal show={open} onHide={onClose} dialogClassName="popup-content" centered>
            <Modal.Body>
            <div className="message">
            <p>שם משתמש או סיסמא שגויים</p>
                    <p>אנא נסה שנית</p>
                </div>
                <Button variant="primary" onClick={onClose}>נסה שנית</Button>
            </Modal.Body>
        </Modal>
    );
};

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [resetCode, setResetCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [step, setStep] = useState(0); // Step tracker: 0 - Login, 1 - Enter Email, 2 - Enter Code, 3 - Reset Password
    const [errorMessage, setErrorMessage] = useState('');
    const { setIsLogged, setUser } = useContext(AppContext);
    const navigate = useNavigate();

    // Handle Login
    const handleLogin = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        const token = await getLoginToken(username, password);
        if (token) {
            const data = await validateToken();
            setUser(data);
            setIsLogged(true);
            Cookies.set('user', JSON.stringify(data), { expires: 7 });
            Cookies.set('isLogged', true, { expires: 7 });
            navigate('/personal_info');
        } else {
            setErrorMessage('שם משתמש או סיסמא שגויים');
        }
    };

    const handleRequest = async (url, payload, successCallback, errorMessage) => {
      try {
          const response = await axios.post(`${SERVER_URL}${url}`, payload);
          const data = response.data;
          if (data.success) {
              successCallback(data);
              setErrorMessage(''); // Clear error on success
          } else {
              setErrorMessage(data.message || errorMessage);
          }
      } catch (error) {
          console.error(`Error in ${url}:`, error.response?.data || error.message);
          setErrorMessage(error.response?.data?.message || errorMessage);
      }
  };
  
  const handleEmailSubmit = async () => {
      handleRequest(
          'request_password_reset/',
          { email },
          () => setStep(2), // Move to Enter Code step
          'שגיאה בשליחת המייל. אנא נסה שוב.'
      );
  };
  
  const handleCodeSubmit = async () => {
      handleRequest(
          'verify_reset_code/',
          { email, code: resetCode },
          () => setStep(3), // Move to Reset Password step
          'הקוד שהוזן אינו נכון. אנא נסה שוב.'
      );
  };
  
  const handlePasswordReset = async () => {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
      if (!passwordRegex.test(newPassword)) {
          setErrorMessage('הסיסמא חייבת לכלול לפחות אות גדולה, אות קטנה, מספר ואורך של 8 תווים.');
          return;
      }
      if (newPassword !== confirmPassword) {
          setErrorMessage('הסיסמאות אינן תואמות.');
          return;
      }
  
      handleRequest(
          'reset_password/',
          { email, code: resetCode, password: newPassword },
          () => {
              alert('הסיסמא שונתה בהצלחה.');
              setStep(0); // Return to login
          },
          'שגיאה באיפוס הסיסמא.'
      );
  };
  

    // Render the correct step
    return (
      <div className="login-container">
          <div className="login-frame">
              {step === 0 && (
                  <>
                      <h2>כניסה</h2>
                      <br/>
                      {errorMessage && <p className="error-message">{errorMessage}</p>}
                      <form onSubmit={handleLogin}>
                          <div className="user-box">
                              <input
                                  type="text"
                                  name="username"
                                  value={username}
                                  onChange={(e) => setUsername(e.target.value)}
                                  required
                              />
                              <label>אימייל </label>
                          </div>
                          <div className="user-box">
                              <input
                                  type="password"
                                  name="password"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  required
                              />
                              <label>סיסמא</label>
                          </div>
                          
                          <button type="submit" className="login-button">כניסה</button>
                      </form>
                      <p onClick={() => setStep(1)} className="forgot-password-link">
                          שכחת את הסיסמה?
                      </p>
                  </>
              )}
              {step === 1 && (
                  <>
                      <h2>איפוס סיסמא</h2>
                      {errorMessage && <p className="error-message">{errorMessage}</p>}
                      <div className="user-box">
                          <input
                              type="email"
                              // placeholder="אימייל"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                          />
                          <label>אימייל</label>
                      </div>
                      <button onClick={handleEmailSubmit} className="login-button">שלח לי קוד למייל</button>
                      <p onClick={() => setStep(0)} className="back-to-login-link">
                          חזור למסך כניסה
                      </p>
                  </>
              )}
              {step === 2 && (
                  <>
                      <h2>איפוס סיסמא</h2>
                      {errorMessage && <p className="error-message">{errorMessage}</p>}
                      <div className="user-box">
                          <input
                              type="text"
                              // placeholder="הזן את הקוד שנשלח"
                              value={resetCode}
                              onChange={(e) => setResetCode(e.target.value)}
                              required
                          />
                          <label>קוד אימות</label>
                      </div>
                      <button onClick={handleCodeSubmit} className="login-button">אשר</button>
                      <p onClick={handleEmailSubmit} className="resend-code-link">
                          לא קיבלתי קוד, שליחה חוזרת
                      </p>
                      <p onClick={() => setStep(0)} className="back-to-login-link">
                          חזור למסך כניסה
                      </p>
                  </>
              )}
              {step === 3 && (
                  <>
                      <h2>איפוס סיסמא</h2>
                      {errorMessage && <p className="error-message">{errorMessage}</p>}
                      <div className="user-box">
                          <input
                              type="password"
                              // placeholder="הזן סיסמא חדשה"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                          />
                          <label>סיסמא חדשה</label>
                      </div>
                      <div className="user-box">
                          <input
                              type="password"
                              // placeholder="הזן סיסמא שוב"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              required
                          />
                          <label>אימות סיסמא</label>
                      </div>
                      <button onClick={handlePasswordReset} className="login-button">שמור</button>
                      <p onClick={() => setStep(0)} className="back-to-login-link">
                          חזור למסך כניסה
                      </p>
                  </>
              )}
          </div>
      </div>
  );
};

export default Login;